import type {MenuItemConfig} from '@myparcel-frontend/ui';
import {Shirt24} from '@myparcel-frontend/icons/legacy';
import {markRaw} from 'vue';

export const getProductsMenu = (): MenuItemConfig => {
  return {
    type: 'parent',
    label: 'products.product',
    multiplyLabel: true,
    icon: markRaw(Shirt24),
    show: () => true,
    children: [
      {
        type: 'internal',
        to: {
          name: 'products',
        },
        label: 'overview',
        show: () => true,
      },
      {
        type: 'internal',
        to: {
          name: 'products-new',
        },
        label: 'products.new',
        show: () => true,
      },
      {
        type: 'internal',
        to: {
          name: 'products-import',
        },
        activeRouteNameAliases: ['products-import-overview', 'products-import-edit'],
        label: 'products.manualImport',
        show: () => true,
      },
    ],
  };
};
